module.exports = __webpack_public_path__ + "media/images/bg/hero/brodno-school-681aee152da16ef744b34cd6f27aac7d.jpg";